import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  { title: 'pages.onboarding.field.marketing', value: 'marketing' },
  { title: 'pages.onboarding.field.finance', value: 'finance' },
  { title: 'pages.onboarding.field.software', value: 'software' },
  { title: 'pages.onboarding.field.sales', value: 'sales' },
  { title: 'pages.onboarding.field.hr', value: 'hr' },
  { title: 'pages.onboarding.field.product', value: 'product' },
  { title: 'pages.onboarding.field.design', value: 'design' },
  { title: 'pages.onboarding.field.operations', value: 'operations' },
  { title: 'pages.onboarding.field.data', value: 'data' },
  { title: 'pages.onboarding.field.legal', value: 'legal' },
]

export default function FieldPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.field.title"
      layout="grid"
    />
  )
}
